<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  phoneNumber: { type: String, default: '' },
  dialerConfig: { type: Object, default: () => ({}) },
});

const { t } = useI18n();

// A voice campaign has no schedule and no message: what matters at a glance is the line it dials
// from and how hard it is allowed to dial.
const rulesSummary = computed(() => {
  const lines = props.dialerConfig?.max_concurrent_lines ?? 8;
  return t(
    'CAMPAIGN.VOICE.CARD.RULES',
    { attempts: props.dialerConfig?.max_attempts ?? 3, lines },
    lines
  );
});
</script>

<template>
  <div class="flex items-center gap-2 text-sm text-n-slate-11 min-w-0">
    <Icon icon="i-lucide-phone" class="flex-shrink-0 size-4" />
    <span class="font-medium text-n-slate-12">{{ phoneNumber }}</span>
    <span class="text-n-slate-8">·</span>
    <span class="truncate">{{ rulesSummary }}</span>
  </div>
</template>
